import { render, staticRenderFns } from "./ConsumptionComparison.vue?vue&type=template&id=20ce5eff&"
import script from "./ConsumptionComparison.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionComparison.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports